<!--  -->
<template>
  <div class="personalCenter">
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <!-- <Foot/> -->
  </div>
</template>

<script>
// import Foot from '@/components/foot/privacy.vue';
export default {
  data() {
    return {
    };
  },

  components: {
    //   Foot
  },

  computed: {},

  mounted() { },

  methods: {},
};

</script>

<style scoped lang="scss">
.personalCenter {
  position: relative;
  //position: absolute;
  width: 100%;
  min-height: 100vh;
  // min-height: 100vh;
  // min-height: calc(100vh - 244px);
  background: #f9f9f9ff;
}
</style>
